import { useCallback } from 'react';
import { useUserEvents } from '../mqtt/hooks';
import { useAuthStore } from '../store/authSlice';
import { MQTTEvent, EVENT_TYPES, UserGroupsChangedPayload } from '../types/event';
import { api } from '../api/client';

/**
 * Hook that listens for group changes and refreshes user data
 * This ensures UI updates when user's groups/permissions change
 */
export function useGroupEventsSync() {
  const { user, updateUser } = useAuthStore();

  const handleEvent = useCallback(async (event: MQTTEvent) => {
    if (!user) return;

    switch (event.type) {
      case EVENT_TYPES.USER_GROUPS_CHANGED: {
        const payload = event.payload as UserGroupsChangedPayload;
        if (payload.user_id === user.id) {
          // Refresh user data to get new groups and permissions
          try {
            const response = await api.get(`/users/${user.id}/with-groups`);
            updateUser({
              groupIds: response.data.groups,
              permissions: response.data.permissions,
            });
            console.log('[useGroupEventsSync] User groups updated');
          } catch (err) {
            console.error('[useGroupEventsSync] Failed to refresh user:', err);
          }
        }
        break;
      }

      case EVENT_TYPES.USER_UPDATED: {
        // Handle other user updates if needed
        break;
      }
    }
  }, [user, updateUser]);

  useUserEvents(handleEvent);
}
